import styled from 'styled-components';

export const StyledTitle = styled.div`
  font-family: MultiplaneTWDC;
  font-size: 48px;
  font-weight: 600;
  line-height: 60px;
  text-align: left;
`;
